import React from "react";
import { NavLink } from "react-router-dom";

export default function DiscountSurfaces() {
  return (
    <div className="discount-surfaces mb-3" role="tablist" aria-label="Discounts">
      <NavLink to="/offers" className="discount-surfaces__link">Offers and promo codes</NavLink>
      <NavLink to="/referral-discounts" className="discount-surfaces__link">Referral codes</NavLink>
    </div>
  );
}
